<div class="px-2 px-lg-4 pt-2 pt-lg-3">
  @if (app()) {
    <div>
      <div class="d-flex justify-content-start">
        <h5 class="small-caps"
            i18n>General</h5>
      </div>
      <ml-mdm-apple-installed-application [installedApplication]="app()"></ml-mdm-apple-installed-application>
      <ml-mdm-command-spinner [commandProgress]="commandProgressManagedApplicationConfiguration">
        <ml-mdm-command-spinner [commandProgress]="commandProgress$">
          @if (isManaged$ | async) {
            <ml-mdm-application-configuration [applicationConfiguration]="applicationConfiguration | async"
                                              (applicationConfigurationChange)="saveApplicationConfiguration($event)"></ml-mdm-application-configuration>
          }
        </ml-mdm-command-spinner>
      </ml-mdm-command-spinner>
    </div>
  }
</div>